export default __webpack_public_path__ + "static/media/CheerIcon.fa739138.svg";